// extracted by mini-css-extract-plugin
export var chevron = "_1h-d";
export var disabled = "_1h-b";
export var error = "_1h-c";
export var hideBorder = "_1h-1";
export var icon = "_1h-e";
export var input = "_1h-0";
export var large = "_1h-f";
export var open = "_1h-9";
export var placeholder = "_1h-a";
export var regular = "_1h-5";
export var singleRowInput = "_1h-2";
export var singleSelectInput = "_1h-3 _1h-0";
export var small = "_1h-4";
export var spinnerContainer = "_1h-i";
export var tag = "_1h-7";
export var tagsContainer = "_1h-8";
export var tagsInput = "_1h-6 _1h-0";
export var xSmall = "_1h-g";
export var xxSmall = "_1h-h";